import routes from '@/Router/routes.constants'

export const getParcelDetailRoute = parcelId => routes.parcelDetailPage.replace(':id', parcelId)
